// extracted by mini-css-extract-plugin
export default {"switch":"src-pages-SalesChannelContentEditor-SalesChannelEditorPromotion-FeaturedProduct-FeaturedProduct__switch--dRXTF"};